import "./style.css";
import PATHS from "../../Routes/paths";
import { Breadcrumb, PopUpModal, Title } from "../../Components/Atoms";
import AddVehicle from "../AddVehicle";
import { Button, useToast } from "@chakra-ui/react";
import { AddModelIcon } from "../../Assets/images/svgs";
import { useNavigate } from "react-router-dom";
import { ImeiCard } from "../../Components/Molecules";
import { useContext, useRef, useState } from "react";
import { StoreContext } from "../../Library/contexts";
import { mapDevToVeh } from "../../APIs";

const MapDeviceToVehicle = () => {
  const navigate = useNavigate();
  const Toast = useToast();
  const addVehicleRef = useRef(null);
  const imeiRef = useRef(null);

  const [imeiValue, setImeiValue] = useState("");
  const [mappingSuccessModal, setMappingSuccessModal] = useState(null);
  const { userVehicles, setUserVehicles } = useContext(StoreContext);

  const breadcrumbPaths = [
    { idx: 1, name: "Live Tracking", link: PATHS.LIVE_TRACKING },
    { idx: 3, name: "Add New Vehicle", link: "", isCurrentPage: true },
  ];

  const handleMapDevice = (imei) => {
    setImeiValue(imei)
    imeiRef.current = imei;
    if (!imei) return;

    addVehicleRef.current?.triggerSubmit();
  };

  const handleValidatedSubmit = (validatedData, vehicleMakes, vehicleModels) => {
    const cleanedData = Object.fromEntries(
      Object.entries({
        ...validatedData,
        imeiValue: imeiValue || imeiRef.current,
      }).filter(([_, v]) => v)
    );

    const makeObj = vehicleMakes?.find(m => m.value === cleanedData.mk);
    const modelObj = vehicleModels?.find(m => m.value === cleanedData.md);

    const finalPayload = {
      mappingDetl: [
        {
          imei: cleanedData.imeiValue,
          mk: cleanedData.mk,
          md: cleanedData.md,
          vtyp: cleanedData.typ,
          mo: modelObj?.label || "",
          vmk: makeObj?.label || "",
          reg: cleanedData.reg,
          idx: 1,
          ftyp: cleanedData.ftyp,
          prod_type: 1,
        },
      ],
      mapOnExistingVeh: false,
    };

    if (cleanedData.chNum) finalPayload.mappingDetl[0].chNum = cleanedData.chNum;

    mapDevToVeh(finalPayload, (err) => {
      if (err) {
        console.error("Mapping failed:", err);
        Toast({ title: err, status: "error", isClosable: true, position: "bottom", });
      }
      else {
        setUserVehicles([ ...userVehicles, { ...validatedData, vmk: makeObj.label, mo: modelObj.label } ]);
        setMappingSuccessModal({
          open: true,
          modalMsg: (
            <div>
              <p>Device Mapping Successful!</p>
              <p>Your Ajjas device has been successfully mapped to the vehicle. You can now start tracking.</p>
            </div>
          ),
          confirmBtn: "Okay",
          onConfirm: () => navigate(PATHS.LIVE_TRACKING),
        });
      }
    });
  };

  return (
    <div className="panel-main map-device-to-vehicle">
      <Breadcrumb paths={breadcrumbPaths} />

      <div className="map-dev-page-header">
        <Title>Enter Vehicle Details</Title>
        <Button
          leftIcon={<AddModelIcon />}
          className="add-btn"
          onClick={() => navigate(`${PATHS.LIVE_TRACKING}/${PATHS.BULK_MAP_DEVICE}`)}
        >
          Bulk Upload
        </Button>
      </div>

      <AddVehicle
        ref={addVehicleRef}
        mapDev={true}
        onSubmit={handleValidatedSubmit}
      />

      <div className="imei-card-title">
        <Title>Map Device to Vehicle</Title>
      </div>

      <ImeiCard onMapDevice={handleMapDevice} />

      <PopUpModal { ...mappingSuccessModal } size={"md"} />
    </div>
  );
};

export default MapDeviceToVehicle;
